export default __webpack_public_path__ + "static/media/Image-18.581f0d08.png";